export enum CallbackResultType {
  // Erro
  Error = -1,
  // Cancelado
  Cancelled = 0,
  // Sucesso
  Success = 1
}